import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../helpers/axiosInstance";

interface userProfileState {
  profile: {
    id: number;
    userId: number;
    shortId: string;
    employeeId: number;
    userName: string;
    designation: string;
    userType: string;
    image: string;
    department: string;
    userEmail: string;
  };
  certificates: [];
  users: [];
}

const initialState: userProfileState = {
  profile: {
    id: 0,
    userId: 0,
    shortId: "",
    employeeId: 0,
    userName: "",
    designation: "",
    userType: "",
    image: "",
    department: "",
    userEmail: "",
  },
  certificates: [],
  users: [],
};

const userProfileSlice = createSlice({
  name: "userProfile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(userProfile.fulfilled, (state, action) => {
        state.profile = action.payload;
      })
      .addCase(getAllCertificates.fulfilled, (state, action) => {
        state.certificates = action.payload;
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.users = action.payload;
      });
  },
});
//export const {fetchEventList} = homeSlice.actions;
export default userProfileSlice.reducer;

export const userProfile = createAsyncThunk(
  "user/userInfo",
  async (userShortId: string = "") => {
    //const response = await axiosInstance.get(`Myprofile/getEvent/1234`)
    const shortId =
      userShortId === "" ? localStorage.getItem("shortId") : userShortId;
    const response = await axiosInstance.get(`api/user/userInfo/${shortId}`);

    return response.data;
  }
);

export const getAllCertificates = createAsyncThunk(
  "getAllCertificates/",
  async (userShortId: string = "") => {
    //const response = await axiosInstance.get(`Myprofile/getEvent/1234`)
    const shortId =
      userShortId === "" ? localStorage.getItem("shortId") : userShortId;
    const response = await axiosInstance.get(
      `api/events/getAllCertificates/${shortId}`
    );

    return response.data;
  }
);

export const generateEventCertificate = createAsyncThunk(
  "generateEventCertificate/",
  async ({ eventId, shortId }: { eventId: string; shortId?: string }) => {
    //const response = await axiosInstance.get(`Myprofile/getEvent/1234`)
    const finalShortId = shortId ?? localStorage.getItem("shortId");
    const response = await axiosInstance.get(
      `api/events/getEventCertificate/${eventId}/${finalShortId}`
    );

    return response.data;
  }
);

export const getEventCertificate = createAsyncThunk(
  "getEventCertificate/",
  async (eventId: any) => {
    //const response = await axiosInstance.get(`Myprofile/getEvent/1234`)
    const shortId = localStorage.getItem("shortId");
    const response = await axiosInstance.get(
      `api/events/getEventCertificate/${eventId}/${shortId}`
    );

    return response.data;
  }
);
export const getAllUsers = createAsyncThunk("getAllUsers/", async () => {
  //const response = await axiosInstance.get(`Myprofile/getEvent/1234`)
  const response = await axiosInstance.get(`api/user/getAllUsers`);

  return response.data;
});
